var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhilippines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask_ph",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask_ph)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 3H25.5V12H-1.5V3Z",
    fill: "#0038A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.5 12H25.5V21H-1.5V12Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3L13.4 12L3 21V3Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.8,
    cy: 12,
    r: 1.5,
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 5.8,
    r: 0.5,
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 18.2,
    r: 0.5,
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.6,
    cy: 12,
    r: 0.5,
    fill: "#FCD116"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhilippines);
export default __webpack_public_path__ + "static/media/Philippines.ca9150f90c2aba150697db91ae683719.svg";
export { ForwardRef as ReactComponent };